module.exports = __webpack_public_path__ + "img/Cheia_intelesului_Bucuresti_1678.cafa3452.png";